var map = {
	"./1.png": 898,
	"./10 - Copy.png": 899,
	"./10.png": 900,
	"./11.png": 901,
	"./12.png": 902,
	"./13.png": 903,
	"./14.png": 904,
	"./15.png": 905,
	"./16.png": 906,
	"./17.png": 907,
	"./18.png": 908,
	"./19.png": 909,
	"./2.png": 910,
	"./20.png": 911,
	"./21.png": 912,
	"./22.png": 913,
	"./24.png": 914,
	"./25.png": 915,
	"./26.png": 916,
	"./27.png": 917,
	"./28.png": 918,
	"./29.png": 919,
	"./31.png": 920,
	"./32.png": 921,
	"./33.png": 375,
	"./34.png": 922,
	"./35.png": 376,
	"./35_old.png": 923,
	"./4.png": 924,
	"./5.png": 925,
	"./6.png": 926,
	"./7.png": 927,
	"./8.png": 928,
	"./9.png": 929,
	"./AAVE.png": 930,
	"./ALCRYP.png": 931,
	"./AMZN.png": 932,
	"./APPL.png": 933,
	"./BCH.png": 934,
	"./BCM.png": 935,
	"./BEAM.png": 936,
	"./BNB.png": 937,
	"./BTC.png": 938,
	"./BTCB.png": 939,
	"./BUSD.png": 940,
	"./CAKE.png": 941,
	"./CHZ.png": 942,
	"./CRYC10.png": 943,
	"./DAI.png": 944,
	"./DOGE.png": 945,
	"./DOT.png": 946,
	"./EPS.png": 947,
	"./EQSTK.png": 948,
	"./ETH.png": 949,
	"./FTM.png": 950,
	"./FTT.png": 951,
	"./GOOGL.png": 952,
	"./IBAT.png": 953,
	"./IN500.png": 954,
	"./INDXXF.png": 955,
	"./INEX.png": 381,
	"./INJ.png": 956,
	"./INXC.png": 957,
	"./INXP.png": 958,
	"./IUSD+.png": 177,
	"./IUSD+_old.png": 959,
	"./IUSD.png": 960,
	"./IUSDP.png": 961,
	"./IUSDP_OLD.png": 962,
	"./IUSD_old.png": 963,
	"./LBlock.png": 964,
	"./LEO.png": 965,
	"./LINK.png": 966,
	"./LTC.png": 967,
	"./MANA.png": 968,
	"./MATIC.png": 969,
	"./META.png": 970,
	"./MSFT.png": 971,
	"./NEAR.png": 972,
	"./NOT.png": 973,
	"./NVDA.png": 974,
	"./PEP.png": 975,
	"./PYTH.png": 976,
	"./RUNE.png": 977,
	"./SHIB.png": 978,
	"./SNP500.png": 979,
	"./SOL.png": 980,
	"./TLSA.png": 981,
	"./TOB.png": 982,
	"./TON.png": 983,
	"./TRX.png": 984,
	"./TUSD.png": 985,
	"./USD.png": 986,
	"./USDC.png": 987,
	"./USDT.png": 988,
	"./WIBS.png": 989,
	"./XRP.png": 990,
	"./eth new PP lpgo 1.png": 991,
	"./inxf.png": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;